import { useLang } from "hooks/useLang"
import Image from "next/image"
import FormulaDescription from "./formulaDescription.mdx"
import FormulaDescription_ar from "./formulaDescription_ar.mdx"

const RenderWhatIsFormula = ({ setSideBarComponent, onShowSidebar }: any) => {
    const { lang } = useLang()
    return (
        <div
            className="w-full flex justify-center md:mt-0 cursor-pointer"
            onClick={() => {
                onShowSidebar()
                setSideBarComponent(() => {
                    const FormulaDescriptionData =
                        lang === "ar" ? (
                            <FormulaDescription_ar />
                        ) : (
                            <FormulaDescription />
                        )
                    return (
                        <div className="flex flex-1 flex-col text-[14px]">
                            <Image
                                alt="formula"
                                src="https://https://cdn.pass-tickets.com/images/f1/whatIsFormula/1.png"
                                width={200}
                                height={200}
                                priority
                                style={{
                                    transform:
                                        lang === "ar"
                                            ? "scaleX(-1)"
                                            : undefined,
                                }}
                                className="w-full  h-auto object-contain sm:px-4 px-2"
                            />
                            {FormulaDescriptionData}
                        </div>
                    )
                })
            }}
        >
            <Image
                alt="formula"
                src="https://cdn.pass-tickets.com/images/f1/whatIsFormula/1.png"
                width={1162}
                height={407}
                priority
                style={{ transform: lang === "ar" ? "scaleX(-1)" : undefined }}
                className="w-full max-w-[1162px] h-auto object-contain sm:px-4 px-2"
            />
        </div>
    )
}

export default RenderWhatIsFormula
